module.exports = __webpack_public_path__ + "static/media/arrow_2.d41d4060.svg";